import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLocationOutlined = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 12,
	height: 16,
	fill: "none",
	viewBox: "0 0 12 16",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M10.5 6C10.5 3.53125 8.46875 1.5 6 1.5C3.5 1.5 1.5 3.53125 1.5 6C1.5 6.53125 1.71875 7.3125 2.25 8.375C2.78125 9.375 3.46875 10.4375 4.1875 11.4375C4.84375 12.3125 5.46875 13.0938 6 13.7188C6.5 13.0938 7.125 12.3125 7.78125 11.4375C8.5 10.4375 9.1875 9.375 9.71875 8.375C10.25 7.3125 10.5 6.53125 10.5 6ZM12 6C12 8.625 8.6875 12.8438 6.96875 14.875C6.375 15.5938 6 16 6 16C6 16 5.59375 15.5938 5 14.875C3.28125 12.8438 0 8.625 0 6C0 2.6875 2.6875 0 6 0C9.3125 0 12 2.6875 12 6ZM7 6C7 5.46875 6.53125 5 6 5C5.4375 5 5 5.46875 5 6C5 6.5625 5.4375 7 6 7C6.53125 7 7 6.5625 7 6ZM3.5 6C3.5 5.125 3.96875 4.3125 4.75 3.84375C5.5 3.40625 6.46875 3.40625 7.25 3.84375C8 4.3125 8.5 5.125 8.5 6C8.5 6.90625 8 7.71875 7.25 8.1875C6.46875 8.625 5.5 8.625 4.75 8.1875C3.96875 7.71875 3.5 6.90625 3.5 6Z"
	})
});
const ForwardRef = forwardRef(SvgLocationOutlined);
export default ForwardRef;
